import Glide from "@glidejs/glide";

document
  .querySelectorAll('.glide-brakes')
  .forEach((slider) => {
    if (slider) {
      const CustomLength = function(Glide, Components, Events) {
        return {
          mount () {
            Events.emit('slider.length', Components.Sizes.length)
          }
        }
      }
    
      const config = {
        perView: 3,
        focusAt: 0,
        gap:10,
        rewind: false,
        type: 'carousel',
        autoheight: true,
        breakpoints: {
          1080: {
            perView: 2
          },
          480: {
            perView: 1
          }
        }
      };
      let glide = new Glide(slider, config)
    
      glide.on('slider.length', (length) => {
        if(length <= 3){
          glide.disable()
        }
      })
      
      glide.mount({
        CustomLength
      })
    }
  } ) 